import { render, staticRenderFns } from "./ButtonSubmit.vue?vue&type=template&id=d819aaea&scoped=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js"
import style0 from "./ButtonSubmit.vue?vue&type=style&index=0&id=d819aaea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d819aaea",
  null
  
)

export default component.exports